import { AutoTextSize } from 'auto-text-size';
import { Bold, Flex } from './TremorCompat';
import { Panel } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';

export const DisplayItem = ({ register, tc = /** @type {any} */ (undefined), icon, borderOff = false }) => {
  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="truncate w-1/2 space-y-2" style={{ display: 'block', width: '50%' }}>
          {/* @ts-expect-error - auto-text-size style prop type is restrictive */}
          <AutoTextSize maxLines={2} maxFontSizePx={18} style={{ color: tc }}>
            {register.title}
          </AutoTextSize>
        </div>
        <div
          className="truncate w-1/2 space-y-1"
          style={{
            display: 'block',
            width: '50%',
          }}
        >
          <Flex justifyContent="end" className="space-x-4 ">
            <AutoTextSize mode="oneline" maxFontSizePx={18}>
              <Bold>{register.display}</Bold>
            </AutoTextSize>
          </Flex>
        </div>
      </Flex>
    </Panel>
  );
};
